<template>
  <div>
    <div class="cm-filter-select">
      <v-icon :disabled="loading" @click="showMenu = true"> mdi-filter </v-icon>
      <p style="color: #182A47 !important">{{ filtersText }}</p>
    </div>
    <Dialog icon="mdi-filter" :display="showMenu" :title="'Select Filters'" @close="showMenu = false" :width="648">

      <div>
        <v-checkbox v-model="allUserActivity" label="All Activity" @click="toggleAll"></v-checkbox>
      </div>
  
      <div class="cm-filters-container">
        <div v-for="item in filters" :key="item.label" style="width: 200px; display: flex; align-items: center; justify-content: space-around">
          <button :class="['cm-filter-item', {selected: selected.includes(item.filter)}]" @click="toggleFilter(item)"> {{ item.label }} </button>
        </div>
      </div>

      <div style="margin-top: 10px; display: flex; flex-direction: row-reverse;">
        <v-btn text @click="submit" :disabled="selectedAndLastSelectedAreTheSame || !selected.length">ok</v-btn>
        <v-btn text @click="showMenu = false">cancel</v-btn>
      </div>
    </Dialog>
  </div>
  
</template>

<script>
import Dialog from '@/components/general/Dialog.vue'
import { Logger } from "aws-amplify"
const logger = new Logger("Select Filters")

export default {
  components: {
    Dialog
  },

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },

    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      showMenu: false,
      selected: ["login","retrieve_video","access_video","delete_video","export_video","access_alert_video","export_alert_video","stream_live_video","stream_recorded_video","share_video", "unshare_video"],
      lastSelected: ["login","retrieve_video","access_video","delete_video","export_video","access_alert_video","export_alert_video","stream_live_video","stream_recorded_video","share_video", "unshare_video"],
      allUserActivity: true
    }
  },

  computed: {
    filters () {
      return [
        {
          "label": "Login",
          "filter": "login"
        },
        {
          "label": "Retrieve Video",
          "filter": "retrieve_video"
        },
        {
          "label": "Access Video",
          "filter": "access_video"
        },
        {
          "label": "Delete Video",
          "filter": "delete_video"
        },
        {
          "label": "Export Video",
          "filter": "export_video"
        },
        {
          "label": "Access Alert Video",
          "filter": "access_alert_video"
        },
        {
          "label": "Export Alert Video",
          "filter": "export_alert_video"
        },
        {
          "label": "Live Video Streaming",
          "filter": "stream_live_video"
        },
        {
          "label": "Remote Video Playback",
          "filter": "stream_recorded_video"
        },
        {
          "label": "Share Video",
          "filter": "share_video"
        },
        {
          "label": "Unshare Video",
          "filter": "unshare_video"
        },
                /*
        {
          "label": "Delete Alert Video",
          "filter": "delete_alert_video"
        },
        */
      ]
    },

    filtersText() {
      return !this.lastSelected.length || this.lastSelected.length == this.filters.length
        ? ' All filters'
          : `${this.lastSelected.length} of ${this.filters.length} filters`
    },

    selectedAndLastSelectedAreTheSame () {
      if(this.selected.length != this.lastSelected.length) {
        return false
      }

      let selectedIds = this.selected
      let lastSelectedIds = this.lastSelected

      for(let x = 0; x < selectedIds.length; x++) {
        if(!lastSelectedIds.includes(selectedIds[x])) {
          return false
        }
      }

      return true
    }
  },

  watch: {
    selected (val) {
      this.allUserActivity = val.length == this.filters.length
    },

    showMenu(val) {
      if(!val) {
        this.$nextTick(() => {
          this.selected = JSON.parse(JSON.stringify(this.lastSelected))
        })
      }
    }
  },

  methods: {
    submit() {
      this.lastSelected = JSON.parse(JSON.stringify(this.selected))
      this.$emit('input', this.selected)
      this.showMenu = false
    },

    toggleAll () {
      this.selected = this.selected.length == this.filters.length
        ? []
        : this.filters.map(i => i.filter)
    },

    toggleFilter(item) {
      this.selected = this.selected.includes(item.filter)
        ? this.selected.filter(i => i != item.filter)
        : [...this.selected, item.filter]

      logger.debug("togglefilter", item)
    }
  }
}
</script>

<style lang="scss">
  .cm-filters-container {
    padding: 15px 0 0 0;
    display: flex;
    flex-direction: row;
    width: 600px;
    flex-wrap: wrap;
    align-items: center;
    background: #EEEEEE;
  }

  .cm-filter-item {
    width: 175px;
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: white;
    border: solid #0f74bb;
    color: #0f74bb;
    border-radius: 10px;
    padding: .5em;
    transition: all .4s;

    &.selected {
      background: #0f74bb !important;
      color: white !important;
    }

    &:hover {
      cursor: pointer;
    }
    &:focus {
      outline:0;
    }
  }
</style>